<script lang="ts">
	//UI
	import { Card, ProductComposite, DefaultButton } from "@hitit/new_ui";
	//Utils
	import { t } from "@hitit/hub/src/stores";
	import { createEventDispatcher } from "svelte";
	import {
		findTrnaslation,
		getKeyInTranslation,
	} from "@hitit/hub/src/v7/utils/";
	import { TranslationDTO } from "../../../class/TranslationDTO";
	import { onlyNumberHandler } from "@hitit/hub/src/v7/utils";
	//Types
	import type OptionItem from "../../../class/StoreItem/OptionItem";
	//Props
	export let item: OptionItem;
	//Constants
	const mandatoryErrorKey = "global.product.error.mandatory";
	const onlyNumberErrorKey = "global.product.error.only_number";
	const onlyPositiveNumberErrorKey =
		"global.product.error.only_positive_number";
	const onlyIntegerNumberErrorKey = "global.product.error.only_interger_number";
	const dispatch = createEventDispatcher();
	//Variables
	let price = "";
	let name = "";
	let inventory = "";
	let nameError = "";
	let priceError = "";
	let stockError = "";
	//Functions
	function clickEventHandler() {
		const dto = item.getOptionCollectionItemDTO();
		const _price = Number(price);
		const _inventory = Number(inventory);
		priceError = isNaN(_price)
			? onlyNumberErrorKey
			: _price < 0
			? onlyPositiveNumberErrorKey
			: !Number.isInteger(_price)
			? onlyIntegerNumberErrorKey
			: price === ""
			? mandatoryErrorKey
			: "";
		stockError =
			inventory !== "" && isNaN(_inventory)
				? onlyNumberErrorKey
				: _inventory < 0
				? onlyPositiveNumberErrorKey
				: !Number.isInteger(_inventory)
				? onlyIntegerNumberErrorKey
				: "";
		nameError = name === "" ? mandatoryErrorKey : "";

		if (priceError || stockError || nameError) {
			return;
		}

		const oldTranslation = findTrnaslation(item.getTranslation(), "ko");
		const translation = oldTranslation
			? TranslationDTO.convinienceConstructor(oldTranslation)
			: new TranslationDTO(name);
		const newTranslations = [
			...item.getTranslation().filter((v) => v.id !== translation.id),
			translation,
		];
		translation.name = name;
		dto.price = _price;
		dto.inventory = _inventory;
		dto.translationDTOs = newTranslations;

		dispatch("EDIT_ITEM_DONE", dto);
	}
	function init(item: OptionItem) {
		price = String(item.price);
		name = getKeyInTranslation(item.getTranslation(), "name", "ko") || "";
		inventory = item.getStockAvailable() ? String(item.getStock()) : "";
		nameError = "";
		priceError = "";
		stockError = "";
	}

	function numberHandler(inputName: "price" | "inventory") {
		const callback = (_: HTMLElement, v: string) => {
			if (inputName === "price") price = v;
			else inventory = v;
		};

		return (e: Event) => {
			const target = e.target as HTMLInputElement;
			onlyNumberHandler(target, callback);
		};
	}
	//Do
	$: init(item);

</script>

<div class="container">
	<Card noPadding>
		<div class="wrapper">
			<div class="input-wrapper">
				<ProductComposite
					inputMode
					placeholder={$t('global.require_input')}
					name={$t('global.product.option_name')}
					error={nameError !== ''}
					errorMessage={$t(nameError)}
					bind:value={name} />
				<ProductComposite
					inputMode
					numeric
					placeholder={$t('global.require_input')}
					error={priceError !== ''}
					errorMessage={$t(priceError)}
					name={$t('global.product.option_price')}
					on:input={numberHandler('price')}
					value={price} />
				<ProductComposite
					numeric
					inputMode
					error={stockError !== ''}
					errorMessage={$t(stockError)}
					name={$t('global.product.stock')}
					on:input={numberHandler('inventory')}
					value={inventory} />
			</div>
			<div class="button">
				<DefaultButton on:click={clickEventHandler} fitmode>
					<span>{$t('global.save')}</span>
				</DefaultButton>
			</div>
		</div>
	</Card>
</div>

<style lang="scss">
	@import "../../../../variables.scss";

	.container {
		display: flex;
		width: 100%;
		flex-direction: column;
	}

	.input-wrapper,
	.wrapper {
		display: flex;
		flex-direction: column;
		width: 100%;
	}

	.input-wrapper {
		gap: 20px;
	}

	.wrapper {
		padding: 20px 10px;
		gap: 20px;
	}

	.button {
		height: 32px;
	}

	span {
		color: white;
		font-weight: 500;
	}

	@include DesktopSize {
		.wrapper {
			padding: 30px;
		}

		span {
			font-size: 1.25rem;
		}

		.button {
			height: 40px;
		}
	}

</style>
